<ion-content scrollY="false">
    <div class="ln-container" *ngIf="pReload">
        <div id="exportlineup" class="field-block">
            <!-- TODO: separate component -->
            <div class="grid-container">
                <div class="field-image-dark"></div>
                <div class="field-image" #bounds
                    [style.background-image]="'url(./assets/lineup/backgrounds/' + activities[gs.planList[activePlan]?.sporttype || ls.field.activity.id].path + '.png)'">
                    <div *ngFor="let block of grid.blocks; let i = index;"
                        [ngClass]="{'active': i == grid.activeBlock, 'block': isMoving }" id="block-{{ i }}">
                    </div>
                </div>
            </div>

            <player-item *ngFor="let player of gs.planList[activePlan]?.teams[activeTeam]?.players; let i = index;" [id]="'player' + i" [player]="player"
                [team]="gamer?.planList[this.activePlan]?.teams[activeTeam]" [bounds]="bounds" (onSave)="onSavePlayer($event)"
                (onChange)="onLocationChange($event)" (onMoving)="onMovingSetState($event)">
            </player-item>
        </div>
        <div class="toolbar-block">
            <toolbar-main *ngIf="activeToolbar == toolbar.team" class="card" [team]="getToolbarPlanName()" [items]="gs.planList" [disabled]="gs.planList[activePlan]?.teams.length" (onSelect)="onPlanSelect($event)" (onClick)="onActionClick($event)">
            </toolbar-main>
            <toolbar-main *ngIf="activeToolbar == toolbar.tshirt" class="card" [team]="getToolbarTeamName()" [items]="gs.planList[activePlan]?.teams" [disabled]="gs.planList[activePlan]?.teams.length" (onSelect)="onTeamSelected($event)" (onClick)="onActionClick($event)">
            </toolbar-main>
            <toolbar-main *ngIf="activeToolbar != toolbar.team && activeToolbar != toolbar.tshirt" class="card" [team]="getToolbarTeamName()" [items]="gs.planList[activePlan]?.teams" [disabled]="gs.planList[activePlan]?.teams.length" (onSelect)="onTeamSelected($event)" (onClick)="onActionClick($event)">
            </toolbar-main>
        </div>
        <div class="content-block">
            <!-- TODO: separate component -->
            <div *ngIf="activeToolbar == toolbar.team" class="content-pagi">
                <paginator *ngIf="pReload"
                    [items]="sort(gs.planList[activePlan]?.teams)"
                    [tshirt]="true" 
                    [addText]="this.getAddTeamText()" 
                    (onAdd)="addTeam()" (onClick)="onTeamSelect($event)">
                </paginator>
            </div>
            <div *ngIf="activeToolbar == toolbar.tshirt" class="content-pagi">
                <paginator *ngIf="pReload"
                    [items]="sort(gs.planList[activePlan]?.teams[activeTeam]?.players)"
                    [tshirt]="true" 
                    [addText]="this.getAddPlayerText()" 
                    (onAdd)="addPlayer()"
                    (onClick)="addPlayer($event)"
                    >
                </paginator>
            </div>
            <div *ngIf="activeToolbar == toolbar.field" class="h-100">
                <paginator [items]="activities" (onClick)="onActivityChange($event)">
                </paginator>
            </div>
        </div>
    </div>
</ion-content>